var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 150182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34235",
    x: 0.695312,
    y: 0.412598,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34236",
    x: 0.695312,
    y: 6.4126,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34237",
    x: 0.695312,
    y: 12.4126,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#F3F3F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.37222f232d44a8f1b9810d9857075d0a.svg";
export { ForwardRef as ReactComponent };